export const keyPokemon = 'favorite_pokemons'

export const LimitList = 20
